
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M13.94 14c.6 0 1.06-.48 1.06-1.1V3.1c0-.62-.46-1.1-1.06-1.1H2.06C1.47 2 1 2.49 1 3.1v2.72c0 .3.24.54.53.54.87 0 1.58.74 1.58 1.64 0 .9-.7 1.64-1.58 1.64-.3 0-.53.24-.53.54v2.73c0 .61.46 1.09 1.06 1.09h11.88zm-3.44-2a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-2a.5.5 0 00-.5.5c0 .28.22.5.5.5a.5.5 0 00.5-.5.5.5 0 00-.5-.5zM5 5.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm1 0a.5.5 0 111 0 .5.5 0 01-1 0zm-.79 6.37a.59.59 0 00.82-.07l5.83-6.86c.21-.25.18-.6-.07-.8a.6.6 0 00-.82.06l-5.83 6.86c-.21.24-.18.6.07.8z"}})])
          )
        }
      }
    